var map = {
	"./qld/religion": 543,
	"./wa/religion": 550
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 509;


//////////////////
// WEBPACK FOOTER
// ../data ^\.\/.*\/religion$
// module id = 509
// module chunks = 0